import { Routes } from '@angular/router';
import { authGuard } from './configs/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DesignSystemComponent } from './pages/design-system/design-system.component';
import { StatementComponent } from './pages/statement/statement.component';
import { LoginComponent } from './pages/login/login.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { ShellComponent } from './shared/shell/shell.component';

/**
 * Application routes.
 *
 * Login stays **outside** the shell: showing a navigation menu to someone with no
 * session makes no sense. The other screens live inside `ShellComponent`, which
 * provides the side menu and the header with the title — each route's `pageTitle`
 * is what the shell renders.
 *
 * The paths stay in Portuguese (`/extrato`, `/relatorios`) because a URL is
 * product surface, like the on-screen labels; only code identifiers follow the
 * fleet's English convention.
 *
 * `/design-system` sits inside the shell but without `authGuard`: it is the
 * showcase used to validate the design, and asking for a login there would only
 * get in the way.
 */
export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard],
        data: { pageTitle: 'Visão geral' },
      },
      {
        path: 'extrato',
        component: StatementComponent,
        canActivate: [authGuard],
        data: { pageTitle: 'Extrato Inteligente' },
      },
      {
        path: 'relatorios',
        component: ReportsComponent,
        canActivate: [authGuard],
        data: { pageTitle: 'Relatórios' },
      },
      {
        path: 'design-system',
        component: DesignSystemComponent,
        data: { pageTitle: 'Design system Getnet' },
      },
      { path: '', redirectTo: 'design-system', pathMatch: 'full' },
    ],
  },
];
